<template>
  <div v-if="currentUser&&currentUser.email=='data.tinkable@gmail.com'">
    <h1 class="documentTitle">
        관리자 서비스
    </h1>
    <div class="m-3">
      <tAdmin/>
    </div>


  </div>
  <div v-else class="gothic">
    <b-alert show fade variant="warning" class="m-0 p-0 pt-3 pb-3 pl-3 fontSizeDot9">
      관리자 시스템 접속권한이 없습니다.
      <router-link :to="{ name: 'tinkHome'}" custom v-slot="{ navigate }">
        <b-button size="sm" variant="primary" style="vertical-align: baseline; padding: 1px 5px 1px 5px;" class="m-0 ml-1 mr-1 cursor-pointer" @click="navigate" @keypress.enter="navigate" role="link">
        처음 화면으로 돌아가기
        </b-button>
      </router-link>
    </b-alert>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import uiUtil from "@/mixins/util.js"

import tAdmin from "@/components/tAdmin.vue"
import { mapState } from "vuex";
import { mapSetter } from "@/plugins/vuexUtils.js";


// import deviceList from "@/components/user/deviceList.vue"
// import authCheck from "@/components/authCheck.vue"

export default {
  name: 'admin',
  mixins: [uiUtil],
  props: {
    mode: {
      type: String,
      default: "serial"
    },
  },
  components: {
    tAdmin
  },
  data : function() {
    return {

    }
  },
  created() {
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      console.log(user);
    })
  },
  methods: {
  },

  computed: {
    ...mapSetter(
      mapState({
        currentUser: state => state.currentUser,
      })
    )
  },

  watch: {

  },
}
</script>
